// extracted by mini-css-extract-plugin
export default {"host":"style_host__ZMW0L","form":"style_form__y0vVA"};